export default {
    mounted(element: HTMLInputElement) {
        element.addEventListener('input', () => {
            element.value = element.value.replace(/[^0-9]/g, '');
        });
    }
};
